module.exports = __webpack_public_path__ + "assets/ac5dbe361bc8582a84c24cf618cec1cf.png";